'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _awaitingreview = require('./awaitingreview.component');

var _awaitingreview2 = _interopRequireDefault(_awaitingreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var awaitingreviewModule = _angular2.default.module('awaitingreview', [_angularUiRouter2.default]).component('awaitingreview', _awaitingreview2.default);

exports.default = awaitingreviewModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/awaitingreview/awaitingreview.js